const integrations = {
  NECTAR: 'nectarcrm',
  RDSTATION: 'rdstation'
};

export default integrations;
